'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ipfsCore = require('ipfs-core');
var path$1 = require('./path.js');

const create = ipfsCore.create;
const crypto = ipfsCore.crypto;
const isIPFS = ipfsCore.isIPFS;
const CID = ipfsCore.CID;
const multiaddr = ipfsCore.multiaddr;
const PeerId = ipfsCore.PeerId;
const globSource = ipfsCore.globSource;
const urlSource = ipfsCore.urlSource;
const path = path$1.path;

exports.CID = CID;
exports.PeerId = PeerId;
exports.create = create;
exports.crypto = crypto;
exports.globSource = globSource;
exports.isIPFS = isIPFS;
exports.multiaddr = multiaddr;
exports.path = path;
exports.urlSource = urlSource;
